import {useTitle} from 'hooks';
import {NavbarCommon, Transitioner} from 'components';

interface INotFoundProps {}

const NotFound = ({}: INotFoundProps) => {
  useTitle('Not Found');
  return (
    <div className="min-h-screen flex flex-col">
      <NavbarCommon />
      <Transitioner>
        <section className="flex flex-col justify-center items-center flex-1 p-6 sm:pt-12 lg:px-8">
          <p className="text-center text-primary text-[140px] md:text-[152px] font-bold -mb-6">404</p>
          <p className="text-center text-xl dark:text-white md:text-2xl font-semibold mb-3">Oops! That page doesn't exist.</p>
          <p className="text-center text-lg mb-6">But don't worry, you can return to the admin portal from here.</p>
          <a
            href={location.origin}
            className="border border-slate-700 p-4 rounded-full transition duration-200 hover:bg-slate-100 dark:hover:bg-slate-700">
            Back to Admin
          </a>
        </section>
      </Transitioner>
    </div>
  );
};

export default NotFound;
